import { createType } from 'framework/utils/createType';

export const RfiaDetailTabTypes = createType('process', 'noahOverview', 'comments');
export type RfiaDetailTabType = typeof RfiaDetailTabTypes[number];
